
const contents = "query InformationBarrierSettingsClients($userId: ID!) {\n  user: node(id: $userId) {\n    ... on User {\n      id\n      officeUserId\n      hasInformationBarrierRestrictions\n    }\n  }\n  viewer {\n    shouldShowInformationBarrierPublisherWarning\n  }\n}\n";
const sha256Hash = "238cb10a1458e444b50a8ed2b057c7586fe63ff3982c65bd4c77d3c516f5b467";
export default { contents: contents, sha256Hash: sha256Hash };
